import SlideoutJS, { Options } from 'slideout';
import config from '../config';
import accordion from '../modules/accordion';
import overlay from '../modules/overlay';
import { debounce, isDesktop } from './utilities';
import filters from '../modules/filters';
import miniBasket from '../modules/miniBasket';
import menu from '../modules/menuSlideout';

interface ISlideoutConfig {
  desktopWidth: number,
  mobileGutter: number
}

interface ISlideout extends SlideoutJS {
  openBtns?: NodeList,
  closeBtns?: NodeList,
  menu?: HTMLElement
}

class Slideout {

  private defaultOptions:Options;
  private slideout:any;
  private config: ISlideoutConfig;

  constructor() {
    this.slideout = null;

    this.config = {
      desktopWidth: 360,
      mobileGutter: config.gutter * 6
    }

    this.defaultOptions = {
      menu: null,
      panel: document.querySelector('[data-slideout-panel]'),
      duration: config.duration,
      touch: false,
      padding: this.config.mobileGutter
    }
  }

  public init(menuNode: HTMLElement, options?: any) {
    this.defaultOptions.menu = menuNode;
    this.defaultOptions.padding = isDesktop() ? this.config.desktopWidth : window.innerWidth - this.config.mobileGutter;
    this.slideout = this.load(this.slideout, options);
    window.addEventListener('resize', this.handleResize.bind(this, this.slideout, options));
    overlay.config.overlay.addEventListener('click', this.handleOverlayClick.bind(this, this.slideout));
    return this.slideout;
  }

  public reinit(slideout: any, options?: any) {
    this.defaultOptions.padding = isDesktop() ? this.config.desktopWidth : window.innerWidth - this.config.mobileGutter;
    slideout = this.destroy(slideout);
    slideout = this.load(slideout, options);
    this.restartModules();
  }

  private restartModules = () => {
    filters.reinit();
    menu.reinit();
    miniBasket.reinit();
  }

  private load = (slideout:ISlideout, options:any) => {
    slideout = new SlideoutJS({ ...this.defaultOptions, ...options });
    slideout.on('beforeopen', this.handleBeforeOpen.bind(this, this.defaultOptions.menu, slideout));
    slideout.on('close', this.handleClose.bind(this, this.defaultOptions.menu, slideout));
    slideout.on('open', this.handleOpen.bind(this, this.defaultOptions.menu, slideout));
    slideout.on('translateend', this.handleTranslateEnd.bind(this, this.defaultOptions.menu, slideout));
    slideout.openBtns = options && options.openBtns ? options.openBtns : null;
    slideout.closeBtns = options && options.closeBtns ? options.closeBtns : null;
    return slideout;
  }

  private handleResize = debounce((slideout: SlideoutJS, options?: any) => {
    this.reinit(slideout, options);
  }, 250);

  private handleOpen = (menu: HTMLElement, slideout:SlideoutJS) => {
    slideout.enableTouch();
    accordion.load();
  }

  private handleBeforeOpen = (menu:HTMLElement) => {
    overlay.on();
    menu.style.width = isDesktop() ? `${ this.config.desktopWidth }px` : `${ window.innerWidth - this.config.mobileGutter }px`;
    menu.classList.add('slideout-menu--active');
  }

  private handleClose = (menu: HTMLElement, slideout: SlideoutJS) => {
    overlay.off();
    slideout.disableTouch();
    menu.classList.remove('slideout-menu--active');
  }

  private handleTranslateEnd = () => {
    overlay.off();
  }

  private handleOverlayClick(slideout: SlideoutJS) {
    slideout.close();
  }

  public destroy(slideout: ISlideout): null {
    if (slideout) {
      slideout.close();
      slideout.destroy();
      slideout.menu.style.width = 'auto';
    }

    if (slideout && slideout.menu) {
      slideout.menu.classList.remove('slideout-menu');
      slideout.menu.classList.remove('slideout-menu-left');
      slideout.menu.classList.remove('slideout-menu-right');
    }

    return null;
  }
}

export default new Slideout();